/* eslint-disable no-use-before-define */
import React from "react";
import { Dropdown } from "semantic-ui-react";
import classNames from "classnames";
import { connectField } from "uniforms";
import { useQuery, gql } from "@apollo/client";
import { IDropdownFieldProps, IFieldCoreProps } from "./_interfaces";
import { alphabetically } from "/imports/utils/functions/fnSortAlphabetically";

import Debug from "debug";
const debug = Debug("forms:costcenterselect");

export const GET_COST_CENTERS = gql`
  query getAccountSettingsCostCenters {
    accountSettings: getAccountSettings {
      id
      costCenters {
        id
        name
        disabled
      }
      costUnits {
        id
        name
        disabled
      }
    }
  }
`;

interface ICostCenterOption {
  id: string;
  name: string;
  disabled?: boolean;
}

export const prepareData = (data: ICostCenterOption[] | null, prefix: string) => {
  return (data || []).map(({ id, name, disabled }, idx) => ({
    key: `${prefix}-${idx}`,
    value: id,
    text: `${name}${disabled ? " (deprecated)" : ""}`,
    disabled: Boolean(disabled),
    content: (
      <span style={{ textDecoration: disabled ? "line-through" : undefined }}>
        {id}
        <span style={{ opacity: 0.8 }}>
          {" - "}
          {name}
          {disabled ? " (disabled)" : ""}
        </span>
      </span>
    )
  })).sort(alphabetically(true, 'name'))
    .sort(alphabetically(false, 'disabled'));
};

export const CostCenterSelect = ({
  disabled,
  id,
  inputRef,
  loading,
  label,
  onChange,
  placeholder,
  required,
  error,
  value,
  className,
  options = []
}: IDropdownFieldProps<string>) => {
  return (
    <div className={classNames("field", { required, error }, className)}>
      <label htmlFor={id}>{label}</label>

      {/* @ts-ignore-next-line TO_FIX_SEMANTIC */}
      <Dropdown
        id={id}
        disabled={disabled}
        ref={inputRef}
        required={required}
        loading={loading}
        fluid
        search
        selection
        label={label}
        value={value}
        options={options}
        placeholder={placeholder}
        onChange={(_, { value: changedValue }) => {
          onChange(changedValue as string);
        }}
      />
    </div>
  );
};

export const CostCenterSelectLoader = props => {
  const { data = {}, loading, error } = useQuery(GET_COST_CENTERS, {
    fetchPolicy: "network-only"
  });

  if (error) debug("error", error);
  const costCenterOptions = prepareData(data.accountSettings?.costCenters, "costCenterItem");

  return <CostCenterSelect loading={loading} options={costCenterOptions} {...props} />;
};

type IFieldProps = IFieldCoreProps<string>;
export default connectField<IFieldProps>(CostCenterSelectLoader);
